module.exports = __webpack_public_path__ + "img/en.218f936f.png";